import { useLanguage } from '../../../contexts/LanguageContext';
import translations from '../../../i18n/translations';

export default function ComparisonTable() {
  const { language } = useLanguage();
  const t = translations[language].comparisonTable;

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.title}</h2>
          <p className="text-lg text-gray-600">
            {t.subtitle}
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-800">
                <th className="px-8 py-5 text-left text-base font-bold text-white">
                  {t.headers.dimension}
                </th>
                <th className="px-8 py-5 text-left text-base font-bold text-white">
                  {t.headers.competitor}
                </th>
                <th className="px-8 py-5 text-left text-base font-bold text-white bg-blue-900">
                  {t.headers.us}
                </th>
              </tr>
            </thead>
            <tbody>
              {t.rows.map((item, index) => (
                <tr
                  key={index}
                  className={`border-b border-gray-200 ${
                    index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                  }`}
                >
                  <td className="px-8 py-6 text-sm font-semibold text-gray-900">
                    {item.dimension}
                  </td>
                  <td className="px-8 py-6">
                    <div className="flex items-start">
                      <i className="ri-close-circle-fill text-red-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm text-gray-600">{item.competitor}</span>
                    </div>
                  </td>
                  <td className="px-8 py-6 bg-blue-50">
                    <div className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-green-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm text-gray-700 font-medium">{item.us}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}